// extracted by mini-css-extract-plugin
export default {"list":"HomeBesooktSkeleton_list__v4k0t","item":"HomeBesooktSkeleton_item__-ojl1"};